import InvoiceService from "@/store/services/invoice.service.js"

export default {
  data () {
    return {
    }
  },
  computed:{

  },
  methods: {
    getUrl (url, item_id = null) {
      let target_url = null
      if (item_id) {
        target_url = window.Urls[url](item_id)
      } else {
        target_url = window.Urls[url]()
      }
      return target_url
    },
    markAsSent () {
      console.log('markAsSent -> mark as sent invoice')
      this.showAdjustModal = true
      this.markedAsSent = true
    },
    creditInvoice (invoice_id) {
      InvoiceService.createCredit(invoice_id).then((response) => {
        this.$router.push({ name: 'InvoiceEdit', params: { invoiceId: response.data.id } })
      })
    }
  }
}